"use client";

import dynamic from "next/dynamic";

const HTMLVideoPlayer = dynamic(() => import("../HTMLPlayer/index.js"), {
  ssr: true,
});

export default HTMLVideoPlayer;